// moment 本地化
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
export default moment;